import Production from '@/components/dialogs/production'
export default {
  components: {
    Production
  },
  methods: {
    onInfoClose() {
      this.$emit('componentInfo', { 
        status: true,
        component: 'billing-list'
      })
    }
  }
}